import Toastify from 'toastify-js'

const showToastify = (message, opts) => {
	Toastify({
		duration: 3000,
		position: "center",
		style: { background: 'rgba(157, 242, 251, 1)', color: 'rgba(0, 0, 0, 0.87)' },
		text: message,
		...opts
	}).showToast();
}

export default showToastify